import { Context } from "preact"
import { PageType } from "./api/types"
import {
    defaultState as baseDefaultState,
    State as BaseState,
    StoreContext as BaseStoreContext,
    createExtendableStore
} from "@nosto/search-js/preact/common"

/**
 * Preact state includes all changing variables of the app.
 * After each change page is automatically rerendered.
 * State includes user input, output and other useful things.
 */
export interface State extends BaseState {
    /**
     * Displays which page type it is - category | search
     */
    pageType: PageType | undefined
    /**
     * Custom params from URL
     */
    customParams: Record<string, unknown>
}

export const defaultState: State = {
    ...baseDefaultState,
    pageType: undefined,
    customParams: {}
}

export function createStore(overrides: Partial<State>) {
    const store = createExtendableStore(defaultState, overrides)
    return {
        ...store,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getInitialState: () => overrides as State
    }
}

export type Store = ReturnType<typeof createStore>

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const StoreContext = BaseStoreContext as unknown as Context<State>
